// Refresh хранится в localStorage, чтобы пережить перезапуск браузера.
// Access НЕ хранится — короткий TTL, безопаснее держать в памяти (восстанавливается
// первым refresh при загрузке страницы).
//
// Refresh ОДНОРАЗОВЫЙ: сервер ротирует его на каждом /v0/auth/refresh. Поэтому localStorage —
// единственный источник истины (in-memory ref только кеш), и запись обязана происходить
// синхронно с получением новой пары, иначе соседняя вкладка отправит потраченный токен.

export const REFRESH_KEY = 'box_refresh_token'
// Кешируем is_admin, чтобы не мигало меню при перезагрузке. Фактическое значение
// всегда перезаписывается из JWT при login/refresh.
const IS_ADMIN_KEY = 'box_is_admin'

export function loadRefresh(): string | null {
  try {
    return localStorage.getItem(REFRESH_KEY)
  } catch {
    return null
  }
}

export function saveRefresh(token: string): void {
  try {
    localStorage.setItem(REFRESH_KEY, token)
  } catch {
    // приватный режим — игнорируем
  }
}

export function clearRefresh(): void {
  try {
    localStorage.removeItem(REFRESH_KEY)
  } catch {
    // игнорируем
  }
}

export function loadIsAdmin(): boolean {
  try {
    return localStorage.getItem(IS_ADMIN_KEY) === 'true'
  } catch {
    return false
  }
}

export function saveIsAdmin(value: boolean): void {
  try {
    if (value) localStorage.setItem(IS_ADMIN_KEY, 'true')
    else localStorage.removeItem(IS_ADMIN_KEY)
  } catch {
    // игнорируем
  }
}

export function clearIsAdmin(): void {
  try {
    localStorage.removeItem(IS_ADMIN_KEY)
  } catch {
    // игнорируем
  }
}

// Напоминание о привязке ключа откладывается на сутки — попап настойчивый, но не бесконечный.
const PASSKEY_SNOOZE_KEY = 'box_passkey_nudge_snoozed_until'
const SNOOZE_MS = 24 * 60 * 60 * 1000

export function isPasskeyNudgeSnoozed(): boolean {
  try {
    const until = localStorage.getItem(PASSKEY_SNOOZE_KEY)
    return until !== null && Number(until) > Date.now()
  } catch {
    return false
  }
}

export function snoozePasskeyNudge(): void {
  try {
    localStorage.setItem(PASSKEY_SNOOZE_KEY, String(Date.now() + SNOOZE_MS))
  } catch {
    // приватный режим — игнорируем
  }
}
